import { render, staticRenderFns } from "./CreateFareBtn.vue?vue&type=template&id=485aa957&"
import script from "./CreateFareBtn.vue?vue&type=script&lang=js&"
export * from "./CreateFareBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports